<template>
    <div id="payroll-component">
        <highcharts
            :constructor-type="'ganttChart'"
            :options="chartOptions"
        ></highcharts>
    </div>
</template>

<script>
export default {
    name: 'payroll-component',
    data() {
        return {
            counter: 2,
            chartOptions: {
                title: {
                    text: 'Gantt Chart with Navigation'
                },
                navigator: {
                    enabled: true,
                    liveRedraw: true,
                    series: {
                    type: 'gantt',
                    pointPlacement: 0.5,
                    pointPadding: 0.25
                    },
                    yAxis: {
                    min: 0,
                    max: 3,
                    reversed: true,
                    categories: []
                    }
                },
                scrollbar: {
                    enabled: true
                },
                rangeSelector: {
                    enabled: true,
                    selected: 0
                },

                yAxis: {
                    type: 'category',
                    categories: ['Tech', 'Marketing', 'Sales', 'Sales', 'Marketing', 'Tech', 'Tech', 'Marketing', 'Sales', 'Tech', 'Marketing', 'Sales'],
                    min: 0,
                    max: 11,
                    uniqueNames: false
                },

                plotOptions: {
                    series: {
                        animation: false, // Do not animate dependency connectors
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}',
                            style: {
                                cursor: 'default',
                                pointerEvents: 'none'
                            }
                        },
                    }
                },

                xAxis: {
                    currentDateIndicator: true
                },

                tooltip: {
                    xDateFormat: '%a %b %d'
                },

                series: [{
                    name: 'Project 1',
                    data: [
                        {
                            start: Date.UTC(2017, 11, 1),
                            end: Date.UTC(2018, 1, 2),
                            name: 'Prototyping',
                            y: 0
                        }, 
                        {
                            start: Date.UTC(2018, 1, 2),
                            end: Date.UTC(2018, 11, 5),
                            name: 'Development',
                            y: 0
                        }, 
                        {
                            start: Date.UTC(2018, 11, 8),
                            end: Date.UTC(2018, 11, 9),
                            name: 'Testing',
                            y: 1,
                        }, 
                        {
                            start: Date.UTC(2018, 11, 9),
                            end: Date.UTC(2018, 11, 19),
                            name: 'Development',
                            y: 1,
                        }, 
                        {
                            start: Date.UTC(2018, 11, 10),
                            end: Date.UTC(2018, 11, 23),
                            name: 'Testing',
                            y: 2
                        }, 
                        {
                            start: Date.UTC(2018, 11, 25),
                            end: Date.UTC(2018, 11, 25),
                            name: 'Release',
                            y: 2
                        },
                        {
                            start: Date.UTC(2018, 11, 25),
                            end: Date.UTC(2018, 11, 25),
                            name: 'Release',
                            y: 3
                        },
                        {
                            start: Date.UTC(2020, 11, 25),
                            end: Date.UTC(2020, 11, 25),
                            name: 'Release',
                            y: 4
                        }
                    ]
                }]
            }
        }
    }
}
</script>